// @flow
import React, {Fragment} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {trigger as edapTrigger, GENERIC_EVENT} from '../../utils/edapWrapper';
import routerActions from '../../actions/router';
import IconButton from '../IconButton/IconButton';
import {CLOSE__24} from '@homeaway/svg-defs';
import {FormattedMessage} from 'react-intl';

import './PinnedProperty.less';

type DispatchProps = {
    removePinnedProperty: typeof routerActions.removePinnedProperty
};

type Props = {
    children: any,
    headline?: string,
    numResults: number
} & DispatchProps;

const getNearbyPropertiesTitle = () => {
    return (
        <h2 className="HitCollection_nearbyTitle">
            <FormattedMessage
                id="expandedSearchNearbyLabel"
                description="Nearby property label"
                defaultMessage="You might like these nearby properties"
            />
        </h2>
    );
};

export const PinnedProperty = ({
    children,
    headline,
    numResults,
    removePinnedProperty
}: Props) => {
    const nearbyProperties = numResults > 1;

    const handleDismiss = () => {
        edapTrigger(GENERIC_EVENT, {
            eventaction: 'dismiss',
            eventcategory: 'pinned-property'
        });
        removePinnedProperty();
    };

    return (
        <Fragment>
            <div className="PinnedProperty">
                <div className="bg--color-brand PinnedContainer--container">
                    <div className="PinnedContainer--header">
                        <h4>{headline}</h4>
                        <IconButton
                            markup={CLOSE__24}
                            onClick={handleDismiss}
                            data-wdio="close"
                        >
                            <span className="sr-only">
                                <FormattedMessage
                                    id="pinnedPropertyCloseLabel"
                                    description="Close button label"
                                    defaultMessage="Close"
                                />
                            </span>
                        </IconButton>
                    </div>
                    {children}
                </div>
            </div>
            {nearbyProperties && getNearbyPropertiesTitle()}
        </Fragment>
    );
};

const mapDispatchToProps = {
    removePinnedProperty: routerActions.removePinnedProperty
};

export default compose(connect(null, mapDispatchToProps))(PinnedProperty);
